import { render, staticRenderFns } from "./simOpens.vue?vue&type=template&id=bafb45b4&scoped=true&"
import script from "./simOpens.vue?vue&type=script&lang=js&"
export * from "./simOpens.vue?vue&type=script&lang=js&"
import style0 from "./simOpens.vue?vue&type=style&index=0&id=bafb45b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafb45b4",
  null
  
)

export default component.exports